import { render, staticRenderFns } from "./SearchTrademarkForCopyForm.vue?vue&type=template&id=dd846b64&"
import script from "./SearchTrademarkForCopyForm.vue?vue&type=script&lang=js&"
export * from "./SearchTrademarkForCopyForm.vue?vue&type=script&lang=js&"
import style0 from "./SearchTrademarkForCopyForm.vue?vue&type=style&index=0&id=dd846b64&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports